
import fetch from '../axios/fetch'
import { encrypt, decrypt } from '@/utils/desensitization'
import newKey from '@/utils/newKeys'
const configs = {
  debug: false,
  appId: 'wx78c3db1740e4a553', // 必填，公众号的唯一标识
  timestamp: '', // 必填，生成签名的时间戳
  nonceStr: '', // 必填，生成签名的随机串
  signature: '',
  jsApiList: ['scanQRCode', 'startRecord', 'stopRecord', 'playVoice', 'stopVoice', 'uploadVoice', 'translateVoice', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'checkJsApi', 'hideMenuItems', 'hideOptionMenu'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
}
const urlList = ['https://wx.emspost.com.cn/servicePageApi/api/wechat/getWxShareDataAes']

const getThirdParameters = async () => {
  const appId = configs.appId
  const url = location.href.split('#')[0]
  const paramsJsonStr = `${JSON.stringify({ appId, url })}`
  const parmasEncrypt = encrypt(paramsJsonStr, newKey[0])
  fetch.post(
    urlList[0],
    {
      data: parmasEncrypt
    },
    'application/json'
  ).then(res => {
    if (res.data.info && res.data.code === '000000') {
      const decryptData = JSON.parse(decrypt(res.data.info, newKey[0]))
      configs.appId = decryptData.appId
      configs.timestamp = decryptData.timestamp
      configs.nonceStr = decryptData.nonceStr
      configs.signature = decryptData.signature
    }
  })
  return configs
}

const doWxConfig = async () => {
  const configs = await getThirdParameters()
  wx.config(configs)
}

export default doWxConfig
